module.exports = __webpack_public_path__ + "img/bible-portal.4d5cc417.svg";